import { useMemo, createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultValue = {
  scopes: new Set(),
  gates: new Set()
};
export const AuthContext = /*#__PURE__*/createContext(defaultValue);
export function useAuthContext() {
  return useContext(AuthContext);
}
export function AuthProvider({
  children,
  gates,
  scopes
}) {
  const value = useMemo(() => {
    return {
      gates: new Set(gates),
      scopes: new Set(scopes)
    };
  }, [gates, scopes]);
  return /*#__PURE__*/_jsx(AuthContext.Provider, {
    value: value,
    children: children
  });
}